import uniqBy from 'lodash/uniqBy'
import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import { renderCardWithProps } from 'react-components/organisms/AreaPersonaleRaccoltaContenutiEditForm/AreaPersonaleRaccoltaContenutiEditForm'

import { api } from '../../utils'
import { ARTICOLI, RACCOLTE, STRUMENTI, UTENTE } from '../../utils/endpoint'

const EventiGenericPageTab = dynamic(() => import('./EventiGenericPageTab'))
const Slider = dynamic(() => import('../Slider'))
const TabProgettoSpecialeCard = dynamic(() => import('../card/TabProgettoSpecialeCard'))

const GenericPageTab = ({ tab, children, progettiSpeciali = false }) => {
  const [raccolte, setRaccolte] = useState([])
  const [strumenti, setStrumenti] = useState([])
  const [articoli, setArticoli] = useState([])

  const [show, setShow] = useState(false)

  const renderItems = (items, titolo) => {
    if (!items.length) return null

    if (progettiSpeciali) {
      return <Slider items={items} titolo={titolo} inTab progettiSpeciali />
    } else {
      return (
        <div className="generic-page-tab__listing">
          {items.map(item => (
            <div className="generic-page-tab__listing__item" key={item.id}>
              {renderCardWithProps(item, { isEmbedded: true })}
            </div>
          ))}
        </div>
      )
    }
  }

  const renderRelatori = () => {
    const relatori = tab.eventi
      .map(e => e.relatori.filter(r => r.utente).map(r => ({ main_image: r.avatar, ...r.utente })))
      .reduce((a, b) => a.concat(b), [])

    if (!relatori.length) return null

    return (
      <div className="generic-page-tab__relatori">
        <Slider items={uniqBy(relatori, 'slug')} titolo="I relatori" type="autori" inTab />
      </div>
    )
  }

  const initializeElementi = async () => {
    if (tab.articoli.length) {
      api
        .get(ARTICOLI, { params: { id__in: tab.articoli.join(','), page_size_custom: 200 } })
        .then(response => setArticoli(response.data.results))
    }
    if (tab.strumenti.length) {
      api
        .get(STRUMENTI, { params: { id__in: tab.strumenti.join(','), page_size_custom: 200 } })
        .then(response => setStrumenti(response.data.results))
    }
    if (tab.raccolte.length) {
      api
        .get(RACCOLTE, { params: { id__in: tab.raccolte.join(','), page_size_custom: 200 } })
        .then(response => setRaccolte(response.data.results))
    }
  }

  const handleAccordion = () => setShow(!show)

  useEffect(() => {
    initializeElementi()
  }, [])

  const eventi = tab.eventi.filter(e => !e.nascosto)

  useEffect(() => {
    if (raccolte.length) checkTools(raccolte, setRaccolte)
  }, [raccolte.length])

  useEffect(() => {
    if (strumenti.length) checkTools(strumenti, setStrumenti)
  }, [strumenti.length])

  useEffect(() => {
    if (articoli.length) checkTools(articoli, setArticoli)
  }, [articoli.length])

  async function checkTools(items, setItems) {
    const params = items.map(({ id, model }) => ({
      content_type_id: model,
      object_id: id,
    }))

    const response = await api.get(UTENTE + 'tools/', { params })
    const enhancedItems = items.map(item => {
      const current = response.data.find(
        e => e.content_type_id === item.model && e.object_id === item.id
      )

      const { saved, following, file_url, pdf_file } = current

      return { ...item, saved, following, extra: { ...item.extra, file_url, pdf_file } }
    })

    setItems(enhancedItems)
  }

  return (
    <div className={`generic-page-tab ${show ? 'open' : ''}`}>
      {progettiSpeciali && <TabProgettoSpecialeCard tab={tab} toggle={handleAccordion} accordion />}
      <section className={`generic-page-tab__content ${progettiSpeciali ? 'speciali' : ''}`}>
        {children}
        {renderItems(raccolte, 'Raccolte')}
        {renderItems(strumenti, 'Materiali')}
        {renderItems(articoli, 'Lezioni & Articoli')}
        {renderRelatori()}
        {eventi.length ? <EventiGenericPageTab eventi={eventi} /> : null}
      </section>
    </div>
  )
}

export default GenericPageTab
